import { render, staticRenderFns } from "./ColorChangerCom.vue?vue&type=template&id=56f5ec70&scoped=true"
import script from "./ColorChangerCom.vue?vue&type=script&lang=js"
export * from "./ColorChangerCom.vue?vue&type=script&lang=js"
import style0 from "./ColorChangerCom.vue?vue&type=style&index=0&id=56f5ec70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5ec70",
  null
  
)

export default component.exports